export default {
    state: {
        userImgUrl: 'http://mpicture.iartschool.com/',
        userVideoUrl: 'http://mvod.iartschool.com/',
        shareUrl: window.location.host.indexOf('test') != -1 ? 'https://gart.iartschool.com/' : 'https://gart.iartschool.com/',
        userinfo: '',
        keepAlive: [],
        androidUrl: "https://a.app.qq.com/o/simple.jsp?pkgname=com.iartschool.gart.android",
        iosUrl: "https://apps.apple.com/cn/app/id1588678226",
        defaultHeaderimg: 'http://image.iartschool.com/headerimg.png',
        uploadUrl: "https://oss.iartschool.com:8443/",
        question: "", //问题列表--问题详情
        reportList: [], //举报信息
        teacherType: [], //老师类别
        baseTypeList:[], //美育基地类型
    }
}